import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteComment } from '../services/api/comments';

export interface DeleteCommentVariables {
  taskId: number;
  commentId: number;
}

/**
 * Phase 25 Plan 25-05 — comment delete mutation.
 *
 * Wait-for-server (D-16). Server soft-deletes (Phase 22 schema); the response
 * is 204 with no body. On success, invalidates ['comments', taskId] so the
 * deleted row drops out of the list.
 */
export function useDeleteComment() {
  const queryClient = useQueryClient();
  return useMutation<void, Error, DeleteCommentVariables>({
    mutationFn: ({ taskId, commentId }) => deleteComment(taskId, commentId),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['comments', vars.taskId] });
    },
  });
}
